import {
  AccountCustomFontFile,
  AccountCustomFontFileStyle,
  AccountCustomFontFileType,
} from 'app/account-settings/account-settings-models';

export default class FontHelpers {
  public static formatFontName(fontName: string) {
    // When font-name contains blankspace we need to ensure having " or ' around it
    if (fontName && fontName.includes(' ') && !fontName.startsWith('"') && !fontName.startsWith("'")) {
      fontName = '"' + fontName + '"';
    }
    return fontName;
  }

  public static getFontFileTypeFromName(fileName: string): AccountCustomFontFileType {
    fileName = fileName.split('?')[0];
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    if (extension === 'woff') {
      return AccountCustomFontFileType.Woff;
    } else if (extension === 'woff2') {
      return AccountCustomFontFileType.Woff2;
    } else if (extension === 'otf') {
      return AccountCustomFontFileType.Otf;
    } else if (extension === 'ttf') {
      return AccountCustomFontFileType.Ttf;
    }
  }

  public static createAccountCustomFileFromUrl(
    url: string,
    fileType: AccountCustomFontFileType,
  ): AccountCustomFontFile {
    const fontFile = {
      url: url,
      type: fileType,
      fileName: url.substring(url.lastIndexOf('/') + 1),
    } as AccountCustomFontFile;
    fontFile.weight = this.autoDetectFontWeightFromFileName(fontFile.fileName);
    fontFile.style = this.autoDetectFontStyleFromFileName(fontFile.fileName);
    return fontFile;
  }

  private static autoDetectFontWeightFromFileName(fileName: string): number {
    const nameLc = fileName.toLowerCase();
    if (nameLc.match(/book|roman|regular|normal/)) {
      return 400;
    }
    if (nameLc.match(/semibold|demibold/)) {
      return 600;
    }
    if (nameLc.match(/extrabold|ultrabold/)) {
      return 800;
    }
    if (nameLc.match(/bold/)) {
      return 700;
    }
    if (nameLc.match(/black|heavy/)) {
      return 900;
    }
    if (nameLc.match(/medium/)) {
      return 500;
    }
    if (nameLc.match(/extralight|ultralight/)) {
      return 200;
    }
    if (nameLc.match(/light/)) {
      return 300;
    }
    if (nameLc.match(/thin/)) {
      return 100;
    }
    return 400;
  }

  private static autoDetectFontStyleFromFileName(fileName: string): AccountCustomFontFileStyle {
    const nameLc = fileName.toLowerCase();
    if (nameLc.indexOf('italic') !== -1) {
      return AccountCustomFontFileStyle.Italic;
    }
    return AccountCustomFontFileStyle.Normal;
  }
}
